<template>
  <div>
    <el-loading v-if="isLoading" fullscreen text="加载中..." />
    <router-view />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElLoading } from 'element-plus'

const router = useRouter()
const isLoading = ref(false)

// 路由切换时显示加载状态
router.beforeEach((to, from, next) => {
  isLoading.value = true
  next()
})

router.afterEach(() => {
  isLoading.value = false
})
</script>

<style>
/* 原有样式不变 */
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif; background-color: #f5f5f5; }
</style>